import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Input, Spin, Button } from "antd";
import ListHeader from "../../molecules/ListHeader/ListHeader";
import { PlusIcon, MinusIcon } from "../../assets/icons";
import GoogleMaps from "../../components/common/GoogleMap";
import {
  createVendor,
  getVendorData,
  updateVendor,
} from "../../services/service";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ButtonLoader from "../../atoms/buttonLoader";
import Phone from "../../atoms/phone";

const { TextArea } = Input;

const AddVendor = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [vendorLoader, setVendorLoader] = useState(false);
  const [vendorData, setVendorData] = useState([]);
  const [mapPosition, setMapPosition] = useState({
    lat: 31.507877,
    lng: 74.336255
  });
  const [currentAddress, setCurrentAddress] = useState("");
  const [locations, setLocations] = useState([]);
  const [apiError, setApiError] = useState("");

  console.log("vendor", vendorData);
  const navigate = useNavigate();
  const location = useLocation();

  const vendorId = location.state?.vendorId;

  console.log("vendor", vendorId);

  useEffect(() => {
    if (vendorId) {
      const fetchVendor = async () => {
        try {
          setVendorLoader(true);
          const response = await getVendorData("", 1, 10, "", vendorId);
          if (response) {
            setVendorData(response?.data?.[0] || []);
            setVendorLoader(false);
            console.log("res", response?.data?.[0]);
          }
        } catch (error) {
          console.error(error);
          setVendorLoader(false);
        } finally {
          setVendorLoader(false);
        }
      };
      fetchVendor();
    }
  }, [vendorId]);

  const formik = useFormik({
    initialValues: {
      vendorName: "",
      description: "",
      addresses: [],
      phone: "",
      email: "",
    },

    validationSchema: Yup.object().shape({
      vendorName: Yup.string().required("Vendor name is required"),
      description: Yup.string().required("Description is required"),
      addresses: Yup.array().min(1, "At least one address is required"),
      phone: Yup.string()
        .trim()
        .required("Phone number is required")
        .min(10, "Phone number must be at least 10 digits")
        .matches(/^\d+$/, "Phone number must only contain digits"),
      email: Yup.string()
        .email("Enter a valid email")
    }),

    onSubmit: async (values) => {
      setIsLoading(true);
      setApiError(""); // Clear previous errors

      const payload = {
        title: values.vendorName,
        phoneNo: values.phone,
        email: values.email,
        description: values.description,
        address: locations.map(loc => ({
          address: loc.address,
          latitude: loc.lat,
          longitude: loc.lng
        }))
      };

      try {
        let response;
        if (vendorId) {
          response = await updateVendor(vendorId, payload);
          if (response?.success) {
            console.log("Vendor updated successfully:", response?.data);
            toast.success("Vendor updated successfully!");
            navigate("/view-vendor");
          } else {
            const errorMessage = response?.message || response?.error || "Failed to update vendor";
            setApiError(errorMessage);
            toast.error(errorMessage);
            console.error("Error updating vendor:", response);
          }
        } else {
          response = await createVendor(payload);
          if (response?.success) {
            console.log("Vendor created successfully:", response?.data);
            toast.success("Vendor added successfully!");
            navigate("/view-vendor");
          } else {
            const errorMessage = response?.message || response?.error || "Failed to create vendor";
            setApiError(errorMessage);
            toast.error(errorMessage);
            console.error("Error creating vendor:", response);
          }
        }
      } catch (error) {
        const errorMessage = error?.response?.data?.message ||
          error?.response?.data?.error ||
          error?.message ||
          "An unexpected error occurred. Please try again.";
        setApiError(errorMessage);
        toast.error(errorMessage);
        console.error("Error calling vendor API:", error);
      } finally {
        setIsLoading(false);
      }
    },
  });

  const handleLocationSelect = (selectedLocation) => {
    setCurrentAddress(selectedLocation?.placeName || "");
    setMapPosition({
      lat: selectedLocation?.lat || 31.507877,
      lng: selectedLocation?.lng || 74.336255
    });
  };


  const addAddress = () => {
    if (currentAddress.trim()) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address: currentAddress }, (results, status) => {
        if (status === "OK" && results[0]) {
          const { lat, lng } = results[0].geometry.location;
          const newLocation = {
            address: currentAddress,
            lat: lat(),
            lng: lng()
          };
          setLocations([...locations, newLocation]);
          formik.setFieldValue("addresses", [...formik.values.addresses, currentAddress]);
          setCurrentAddress("");
        }
      });
    }
  };

  // Ensure any typed address gets added before submit so validation passes
  const ensureAddressForSubmit = () => {
    if (currentAddress.trim()) {
      addAddress();
    }
  };

  const removeAddress = (index) => {
    const newLocations = [...locations];
    newLocations.splice(index, 1);
    setLocations(newLocations);

    const newAddresses = [...formik.values.addresses];
    newAddresses.splice(index, 1);
    formik.setFieldValue("addresses", newAddresses);
  };

  useEffect(() => {
    if (vendorId && vendorData) {
      // Handle locations data based on vendorAddress array
      if (vendorData?.vendorAddress && Array.isArray(vendorData.vendorAddress) && vendorData.vendorAddress.length > 0) {
        const newLocations = vendorData.vendorAddress.map((item, index) => {
          return {
            id: item.id,
            address: item.address,
            lat: item.latitude || vendorData.latitude || 31.507877,
            lng: item.longitude || vendorData.longitude || 74.336255
          };
        });

        setLocations(newLocations);
        formik.setFieldValue("addresses", newLocations.map(loc => loc.address));

        // Set map position to the first location
        setMapPosition({
          lat: vendorData.latitude || 31.507877,
          lng: vendorData.longitude || 74.336255
        });

      }
      // Fallback to old format if vendorAddress is not available
      else if (vendorData?.address) {
        const initialLocation = {
          address: vendorData.address,
          lat: vendorData.latitude || 31.507877,
          lng: vendorData.longitude || 74.336255
        };
        setLocations([initialLocation]);
        formik.setFieldValue("addresses", [initialLocation.address]);

        setMapPosition({
          lat: vendorData.latitude || 31.507877,
          lng: vendorData.longitude || 74.336255
        });
      }
    }
  }, [vendorId, vendorData]);

  useEffect(() => {
    if (vendorId && vendorData) {
      formik.setValues({
        vendorName: vendorData?.title || "",
        description: vendorData?.description || "",
        addresses: locations.map(loc => loc.address),
        phone: vendorData?.phoneNo || "",
        email: vendorData?.email || "",
      });
    }
  }, [vendorId, vendorData, locations]);

  return (
    <>
      <ListHeader
        mainHeading="Vendor"
        placeholder="Search"
        btnShow={true}
        linkBreadCrum="/view-vendor"
        blinkBreadCrumText="Vendor"
        blinkBreadCrumText3={`${vendorId ? "Update Vendor" : "Add Vendor"}`}
        searchShow={false}
        showLikeFilter={false}
        DropDown={false}
      />
      {
        vendorLoader ? (
          <div className="flex justify-center">
            <Spin />
          </div>

        ) :
          <div className="px-6 pt-6 mt-4 bg-white border border-[#E9E9E9] rounded-md shadow-sm">
            <h2 className="text-[20px] font-semibold text-[#1E3A8A] mb-6">
              {vendorId ? "Update Vendor Details" : "Vendor Details"}
            </h2>
            <form onSubmit={formik.handleSubmit}>
              <div className="grid grid-cols-2 gap-4">
                {/* Vendor Name */}
                <div className="mb-4">
                  <Input
                    name="vendorName"
                    placeholder="Vendor name"
                    value={formik.values.vendorName}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={`w-full h-[52px] border ${formik.touched.vendorName && formik.errors.vendorName
                        ? "border-red-500"
                        : "border-[#E9E9E9]"
                      } rounded-[4px]`}
                  />
                  {formik.touched.vendorName && formik.errors.vendorName && (
                    <div className="text-red-500 text-sm mt-1">
                      {formik.errors.vendorName}
                    </div>
                  )}
                </div>

                {/* Email */}
                <div className="mb-4">
                  <Input
                    name="email"
                    placeholder="Email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={`w-full h-[52px] border ${formik.touched.email && formik.errors.email
                        ? "border-red-500"
                        : "border-[#E9E9E9]"
                      } rounded-[4px]`}
                  />
                  {formik.touched.email && formik.errors.email && (
                    <div className="text-red-500 text-sm mt-1">
                      {formik.errors.email}
                    </div>
                  )}
                </div>
              </div>

              {/* Phone */}
              <div className="mb-4">
                <Phone
                  name="phone"
                  value={formik.values.phone}
                  handleChange={(value, name) => formik.setFieldValue(name, value)}
                  field={{
                    onChange: formik.handleChange,
                    onBlur: formik.handleBlur,
                    ref: formik.getFieldProps("phone").ref,
                  }}
                  label="Phone Number"
                />
              </div>

              {/* Address and Map */}
              <div className="mb-4">
                <div className="flex items-center mb-2">
                  <Input
                    placeholder="Address"
                    value={currentAddress}
                    onChange={(e) => setCurrentAddress(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        addAddress();
                      }
                    }}
                    className="w-full h-[52px] border border-[#E9E9E9] rounded-[4px] mr-2"
                  />
                  <Button
                    type="primary"
                    icon={<span className="[&>svg]:w-4 [&>svg]:h-4 [&_path]:stroke-white">{PlusIcon}</span>}
                    onClick={addAddress}
                    className="h-[52px] flex items-center justify-center no-after"
                    style={{ backgroundColor: '#1E3A8A', borderColor: '#1E3A8A' }}
                  />
                </div>

                {/* Display added addresses */}
                {locations.length > 0 && (
                  <div className="mb-4">
                    <h3 className="text-sm font-medium mb-2">Added Locations:</h3>
                    <div className="space-y-2">
                      {locations.map((loc, index) => (
                        <div key={index} className="flex items-center justify-between p-2 bg-gray-50 rounded-md">
                          <span>{loc.address}</span>
                          <div className="flex items-center">
                            <span className="text-xs text-gray-500 mr-2">
                              ({loc.lat.toFixed(6)}, {loc.lng.toFixed(6)})
                            </span>
                            <Button
                              type="text"
                              danger
                              icon={<span className="[&>svg]:w-4 [&>svg]:h-4">{MinusIcon}</span>}
                              onClick={() => removeAddress(index)}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}


                {formik.touched.addresses && formik.errors.addresses && (
                  <div className="text-red-500 text-sm mt-1">
                    {formik.errors.addresses}
                  </div>
                )}

                <div className="mt-6 mb-4">
                  <GoogleMaps
                    onLocationSelect={handleLocationSelect}
                    initialPosition={mapPosition}
                    initialAddress={currentAddress}
                  />
                </div>
              </div>

              {/* Description */}
              <div className="mb-4">
                <TextArea
                  name="description"
                  placeholder="Description"
                  value={formik.values.description}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={`w-full !h-[156px] border ${formik.touched.description && formik.errors.description
                      ? "border-red-500"
                      : "border-[#E9E9E9]"
                    } rounded-[4px]`}
                />
                {formik.touched.description && formik.errors.description && (
                  <div className="text-red-500 text-sm mt-1">
                    {formik.errors.description}
                  </div>
                )}
              </div>

              {/* API Error Display */}
              {apiError && (
                <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-md">
                  <div className="text-red-600 text-sm">
                    <strong>Error:</strong> {apiError}
                  </div>
                </div>
              )}

              {/* Submit Button */}
              <button
                type="submit"
                onClick={ensureAddressForSubmit}
                className="w-[152px] mt-4 mb-[10rem] h-[44px] bg-[#F97316] text-white font-medium text-[20px] rounded-[4px] hover:bg-orange-600"
              >
                {isLoading ? <ButtonLoader /> : vendorId ? "Update" : "Submit"}
              </button>
            </form>
          </div>
      }
    </>
  );
};

export default AddVendor;
